import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HomePageServices from "../services/home.service";
import { setMessage } from "./alertMessageSlice";


export const StartTheConv = createAsyncThunk(
    'StartTheConv',
    async (body, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
            const sess = await HomePageServices.StartTheConv(
                brandUser?.tenant_id,
                body
            );

            await thunkAPI.dispatch(GetAllChats());
            const bd = {
                "category": body?.category,
                "channel_names": body?.channel_names,
                "job_id": body?.job_id,
                "calling_agent": body?.calling_agent,
                "user_prompt": body?.user_prompt,
                "session_id": sess?.session_id
            }
            const data = await HomePageServices.ChatConv(
                brandUser?.tenant_id,
                bd
            );
            let newData = {
                category: body?.category,

                "category": body?.category || [],
                "channel_names": body?.channel_names || [],
                "job_id": body?.job_id || [],
                "calling_agent": body?.calling_agent || '',
                "session_id": data?.session_id,
                messages: [],
            };
            newData.messages.push({
                created_at: new Date().toISOString(),
                message: 
                body?.calling_agent == 'dashboard_agent' ?
                 "Hi, I'm your Data Intelligence Agent, your always-on explainer turning raw data into visuals and trends you can act on. How may I assist you today?" : 
                 body?.calling_agent == "marketing_agent" ?
                 "Hi, I'm your Strategic Marketing Agent. How may I assist you Today":
                 "Hi, I'm your Alert Agent. How may I assist you Today",
                role: "Agent",
                source:body?.channel_names || [],
            });
            newData.messages.push({
                created_at: new Date().toISOString(),
                message: body?.user_prompt || 'How are you',

                role: "User",
            });

            // Add loading agent message
            // newData.messages.push({
            //     created_at: new Date().toISOString(),
            //     message: "",
            //     status: "Loading",
            //     role: "Agent",
            // });

            thunkAPI.dispatch(setChartData(newData));

            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message) ||
                
                        error?.response?.data?.detail
                ) ||
                error.message ||
                error?.detail ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const updateTheChat = createAsyncThunk(
    'updateTheChat',
    async (body, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
            const data = await HomePageServices.ChatConv(
                brandUser?.tenant_id,
                body
            );
            const state = thunkAPI.getState();
            const existingMessages = state?.ConsoleBuilder?.getChartData?.messages || [];
            let newData = {
                ...state?.ConsoleBuilder?.getChartData,
                messages: [...existingMessages],
            };
            newData.messages.push({
                created_at: new Date().toISOString(),
                message: body?.user_prompt || 'How are you',

                role: "User",
            });

            // Add loading agent message
            // newData.messages.push({
            //     created_at: new Date().toISOString(),
            //     message: "",
            //     status: "Loading",
            //     role: "Agent",
            // });
            thunkAPI.dispatch(setChartData(newData));
            // Final fetch after completion

            // thunkAPI.dispatch(setReload(true));
            // await thunkAPI.dispatch(GetChartDataFunc({ session_id: body?.session_id,body: data }));

            const refreshed = await thunkAPI.dispatch(
                RefreshChatFunc({ session_id: body?.session_id, body: data })
            ).unwrap();

            thunkAPI.dispatch(setChartData(refreshed?.data));

            // return refreshed?.data || {};
            return { data };
        } catch (error) {

            const message =
                (error?.response &&
                    (error?.response?.data?.detail?.[0]?.msg ||
                        error?.response?.data?.detail || 
                        error?.response?.data?.message)) ||
                error?.message ||
                error?.detail ||
                error?.toString();
            thunkAPI.dispatch(
                setMessage({
                    message: message,
                    type: 'rejected',
                })
            );
            return thunkAPI.rejectWithValue();
        }
    }
);

export const GetAllChats = createAsyncThunk(
    'GetAllChats',
    async (thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
            const data = await HomePageServices.getAllChats(
                brandUser?.tenant_id
            )
            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const GetChartDataFunc = createAsyncThunk(
    'GetChartDataFunc',
    async ({ session_id, body }, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
            const data = await HomePageServices.getTheConv(
                brandUser?.tenant_id,
                session_id
            )
            if (body) {

                const refreshed = await thunkAPI.dispatch(
                    RefreshChatFunc({ session_id, body: body })
                ).unwrap();

                thunkAPI.dispatch(setChartData(refreshed?.data));

                return refreshed?.data || {};
            } else {
                return data;
            }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const RefreshChatFunc = createAsyncThunk(
    'RefreshChatFunc',
    async ({ session_id, body }, thunkAPI) => {
      try {
        const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
        const curMesgLen = thunkAPI.getState()?.ConsoleBuilder?.getChartData?.messages.length || 0;
  
        const refreshPreviewData = async () => {
          thunkAPI.dispatch(GetAllChats());
          await new Promise((resolve) => setTimeout(resolve, 1000));
  
          const getStatus = await HomePageServices.getStatusConv(
            brandUser?.tenant_id,
            body?.agent_message_id
          );
  
          const currentStatus = thunkAPI.getState()?.ConsoleBuilder?.getStatusData;
  
          if (getStatus && JSON.stringify(currentStatus) !== JSON.stringify(getStatus)) {
            thunkAPI.dispatch(setStatusData(getStatus));
  
            const state = thunkAPI.getState();
            const existingMessages = state?.ConsoleBuilder?.getChartData?.messages || [];
  
            const newMessages = [...existingMessages];
  
            const hasTaskMessage = newMessages.some(
              (msg) => msg.role === 'task' && msg.status === 'In-Progress'
            );
  
            if (!hasTaskMessage) {
              // Append new "task" + "agent loading" messages only once
              newMessages.push({
                created_at: new Date().toISOString(),
                message: '',
                role: 'task',
                status: 'In-Progress',
                task_details: getStatus?.task_details || [],
              });
  
              newMessages.push({
                created_at: new Date().toISOString(),
                message: '',
                role: 'Agent',
                status: 'Loading',
              });
            } else {
              // Update the existing task message with new details
              const taskIndex = newMessages.findIndex(
                (msg) => msg.role === 'task' && msg.status === 'In-Progress'
              );
              if (taskIndex !== -1) {
                newMessages[taskIndex] = {
                  ...newMessages[taskIndex],
                  task_details: getStatus?.task_details || [],
                };
              }
            }
  
            thunkAPI.dispatch(
              setChartData({
                ...state?.ConsoleBuilder?.getChartData,
                messages: newMessages,
              })
            );
          }
  
          if (getStatus?.status === 'Completed') {
            return;
          } else {
            await new Promise((resolve) => setTimeout(resolve, 12000));
            return refreshPreviewData(); // recurse until completed
          }
        };
  
        await refreshPreviewData();
  
        const data = await HomePageServices.getTheConv(
          brandUser?.tenant_id,
          session_id
        );
  
        return { data };
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            (error.response.data.detail || error.response.data.message)) ||
          error.message ||
          error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue();
      }
    }
  );
  
export const getConsoleDashBoard = createAsyncThunk(
    'getConsoleDashBoard',
    async (body, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
            const data = await HomePageServices.getHomePage(
                brandUser?.tenant_id,
                brandUser?.user_details.user_id,
                body
            );
            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const DeleteChatData = createAsyncThunk(
    'DeleteChatData',
    async (session_id, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
            const data = await HomePageServices.DeleteChatData(
                brandUser?.tenant_id,
                session_id
            )
            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
function parseQueryStringToArray(queryStr) {
    const groupRegex = /\(([^()]+)\)/g;
    const result = [];
    let match;
    const combinators = [];

    // Extract group combinators between parenthesis
    const combinatorMatches = queryStr.match(/\)\s*(AND|OR)\s*\(/g);
    if (combinatorMatches) {
        combinators.push(...combinatorMatches.map(str => str.trim().replace(/[()]/g, '')));
    }

    let groupIndex = 0;

    // Extract group contents
    while ((match = groupRegex.exec(queryStr)) !== null) {
        const groupContent = match[1].trim();
        const keywords = groupContent.split(/\s+(AND|OR)\s+/);

        const group = [];
        let innerCombinator = 'AND'; // Default
        for (let i = 0; i < keywords.length; i++) {
            const word = keywords[i].trim();
            if (word === 'AND' || word === 'OR') {
                innerCombinator = word;
            } else {
                group.push({
                    value: word,
                    keywordType: 'Word',
                });
            }
        }

        result.push({
            group,
            combinator: innerCombinator,
            combinatorWithNextGroup: combinators[groupIndex] || 'OR',
        });

        groupIndex++;
    }

    // Optional: Clean up the last group's outer combinator
    if (result.length > 0) {
        result[result.length - 1].combinatorWithNextGroup = 'OR'; // or null/undefined
    }

    return result;
}
export const getKeywordTrends = createAsyncThunk(
    'getKeywordTrends',
    async (body, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

            // const body = { "query": queryString }
            const data = await HomePageServices.getKeywordTrends(
                brandUser?.tenant_id,
                brandUser?.user_details.user_id,
                body
            );
            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const renameTheTitle = createAsyncThunk(
    'renameTheTitle',
    async ({ session_id, body }, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

            // const body = { "query": queryString }
            const data = await HomePageServices.renameTheTitle(
                brandUser?.tenant_id,
                session_id,
                body
            );
            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


export const matViewRef = createAsyncThunk(
    'matViewRef',
    async (body, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

            // const body = { "query": queryString }
            const data = await HomePageServices.matViewRef(
                brandUser?.tenant_id
            );
            return { data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    (error.response.data.detail || error.response.data.message)) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


const initialState = {
    isLoadingVal: false,
    isConvLoading: false,
    isConvLoadingInitial: false,
    isKeywordLoading: false,
    chatLoader: false,
    getChartData: null,
    getStatusData: null,
    startConvData: null,
    getConsoleData: null,
    keywordErrorHomePage: '',
    getKeywordData: null,
    reload: true,
    getAllChatsData: null,
    inputError: '',
    showChannel:false,
    jobDetails:null,
    queryPromptValue:''

};

const consoleSlice = createSlice({
    name: 'ConsoleBuilder',
    initialState,
    reducers: {
        setDummyChartData: (state, action) => {
            state.getChartData = action.payload;
        },
        clearKeywordData: (state, action) => {
            state.getKeywordData = null;
        },
        setKeywordErrorHomePage: (state, action) => {
            state.keywordErrorHomePage = action.payload;
        },
        setChartData: (state, action) => {
            state.getChartData = action.payload;
        },
        setStatusData: (state, action) => {
            state.getStatusData = action.payload;
        },
        setReload: (state, action) => {
            state.reload = action.payload
        },
        setInputError: (state, action) => {
            state.inputError = action.payload
        },
        setShowChannel: (state, action) => {
            state.showChannel = action.payload
        },
        setJobDetails: (state, action) => {
            state.jobDetails = action.payload
        },
        setQueryPromptValue: (state, action) => {
            state.queryPromptValue = action.payload
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(updateTheChat.rejected, (state, action) => {
                state.isConvLoading = false;
            })
            .addCase(updateTheChat.pending, (state, action) => {
                state.isConvLoading = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(updateTheChat.fulfilled, (state, action) => {
                state.isConvLoading = false;
                state.startConvData = action.payload;
            })

            .addCase(GetAllChats.rejected, (state, action) => {
                state.isConvLoading = false;
            })
            .addCase(GetAllChats.pending, (state, action) => {
                state.isConvLoading = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(GetAllChats.fulfilled, (state, action) => {
                state.isConvLoading = false;
                state.getAllChatsData = action?.payload?.data || [];
            })

            .addCase(RefreshChatFunc.rejected, (state, action) => {
                state.isConvLoading = false;
            })
            .addCase(RefreshChatFunc.pending, (state, action) => {
                state.isConvLoading = true;
                // state.searchInstaValue = action.payload?.data;
            })
            // .addCase(RefreshChatFunc.fulfilled, (state, action) => {
            //     state.isConvLoading = false;
            //     state.getAllChatsData = action?.payload?.data || [];
            // })


            .addCase(DeleteChatData.rejected, (state, action) => {
                state.isConvLoading = false;
            })
            .addCase(DeleteChatData.pending, (state, action) => {
                state.isConvLoading = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(DeleteChatData.fulfilled, (state, action) => {
                state.isConvLoading = false;
            })


            .addCase(GetChartDataFunc.rejected, (state, action) => {
                state.chatLoader = false;
            })
            .addCase(GetChartDataFunc.pending, (state, action) => {
                state.chatLoader = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(GetChartDataFunc.fulfilled, (state, action) => {
                state.chatLoader = false;
                state.getChartData = action.payload;
            })

            .addCase(StartTheConv.rejected, (state, action) => {
                state.isConvLoadingInitial = false;
            })
            .addCase(StartTheConv.pending, (state, action) => {
                state.isConvLoadingInitial = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(StartTheConv.fulfilled, (state, action) => {
                state.isConvLoadingInitial = false;
                state.startConvData = action.payload;
            })
            .addCase(getConsoleDashBoard.rejected, (state, action) => {
                state.isLoadingVal = false;

            })
            .addCase(getConsoleDashBoard.pending, (state, action) => {
                state.isLoadingVal = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(getConsoleDashBoard.fulfilled, (state, action) => {
                state.isLoadingVal = false;

                const rawQuery = action.payload?.data?.keyword_query || '';
                const queryString = rawQuery.trim()
                    ? parseQueryStringToArray(rawQuery)
                    : [
                        {
                            group: [{ value: '', keywordType: 'Word' }],
                            combinator: 'AND',
                            combinatorWithNextGroup: 'AND',
                        },
                    ];


                state.getConsoleData = {
                    ...action.payload?.data,
                    queryString: queryString,
                };
            })



            .addCase(renameTheTitle.rejected, (state, action) => {

            })
            .addCase(renameTheTitle.pending, (state, action) => {
            })
            .addCase(renameTheTitle.fulfilled, (state, action) => {
            })

            .addCase(getKeywordTrends.rejected, (state, action) => {
                state.isKeywordLoading = false;

            })
            .addCase(getKeywordTrends.pending, (state, action) => {
                state.isKeywordLoading = true;
                // state.searchInstaValue = action.payload?.data;
            })
            .addCase(getKeywordTrends.fulfilled, (state, action) => {
                state.isKeywordLoading = false;
                state.getKeywordData = action.payload;
            })

    }

})


export const {
    clearKeywordData,
    setKeywordErrorHomePage,
    setReload,
    setDummyChartData,
    setChartData,
    setStatusData,
    setInputError,
    setShowChannel,
    setJobDetails,
    setQueryPromptValue

} = consoleSlice.actions;

export default consoleSlice.reducer;
